import sharedSv from "@boark/shared/locale/sv";

import { Locale } from "./locale.type";

export default {
  title: "Boark",
  home: "Hem",
  locale: {
    english: "Engelska",
    swedish: "Svenska",
  },
  login: {
    title: "Logga in",
    email: "E-postadress",
    password: "lösenord",
    submit: "Logga in",
    error: "Ogiltiga inloggningsuppgifter",
  },
  auth: {
    registerLink: "Skapa konto",
    resetPasswordLink: "Återställ lösenord",
    backToLogin: "Tillbaka till inloggning",
    registerTitle: "Registrera",
    registerSubmit: "Skapa konto",
    registerError: "Kunde inte skapa konto",
    registerSuccessTitle: "Kontrollera din e-post",
    registerSuccessBody:
      "Vi har skickat en aktiveringslänk. Aktivera kontot innan du loggar in.",
    associationName: "Föreningens namn",
    associationDomain: "Föreningens domän",
    organizationNumber: "Organisationsnummer",
    activateTitle: "Aktivera konto",
    activateLoading: "Aktiverar ditt konto...",
    activateSuccess: "Ditt konto är aktivt. Du kan logga in nu.",
    activateError: "Aktiveringslänken är ogiltig eller har gått ut.",
    resetRequestTitle: "Återställ lösenord",
    resetRequestSubmit: "Skicka återställningslänk",
    resetRequestSuccessTitle: "Kontrollera din e-post",
    resetRequestSuccessBody:
      "Om det finns ett konto för den adressen har vi skickat en återställningslänk.",
    resetConfirmTitle: "Välj nytt lösenord",
    resetConfirmSubmit: "Uppdatera lösenord",
    resetConfirmSuccess: "Ditt lösenord har uppdaterats.",
    resetError: "Kunde inte återställa lösenord",
    inviteAcceptTitle: "Acceptera inbjudan",
    inviteAcceptSubmit: "Gå med i föreningen",
    inviteAcceptSuccess: "Ditt konto är klart. Du kan logga in nu.",
    inviteAcceptError: "Inbjudningslänken är ogiltig eller har gått ut.",
    adminUsersTitle: "Medlemmar",
    memberTypeOwner: "Ägare",
    memberTypeMember: "Medlem",
    membersEmpty: "Inga medlemmar ännu.",
    adminUsersEmpty: "Du äger inga föreningar ännu.",
    associationLabel: "Förening",
    inviteSubmit: "Skicka inbjudan",
    inviteSuccess: "Inbjudan skickad.",
    inviteError: "Kunde inte skicka inbjudan",
    controlStartMenu: "Start",
    controlStartTitle: "Välj förening",
    controlStartIntro:
      "Välj en förening du äger för att hantera inbjudningar, eller skapa en ny.",
    controlStartOwnedHeading: "Dina föreningar",
    controlStartCreateHeading: "Skapa ny förening",
    controlStartCreateSubmit: "Skapa och fortsätt",
    controlStartCreateError: "Kunde inte skapa förening",
    controlStartLoadError: "Kunde inte läsa in dina föreningar.",
    controlStartChangeAssociation: "Välj annan förening",
    associationCreateTitle: "Skapa förening",
    associationEditTitle: "Redigera förening",
    associationEditLink: "Redigera",
    backToAssociationStart: "Tillbaka till föreningar",
    associationFormError: "Kunde inte spara föreningen",
    adminUsersForAssociation: "Inbjudningar skickas för",
  },
  logout: "Logga ut",
  send: {
    title: "Skicka",
    submit: "Skicka",
  },
  page: {
    updatedAt: "Uppdaterad",
    edit: "Redigera",
    cancel: "Avbryt",
    save: "Spara",
    noContent: "Innehåll saknas, kontrollera igen senare",
    noContentInAlternative: "Innehåll saknas, kontrollera huvudspråket",
    noRoles: "Inga roller att visa",
    type: "Sidtyp",
    typeContent: "Innehåll",
    typeRoles: "Roller",
  },
  search: {
    title: 'Sökresultat för "{query}"',
    found: "Hittade {count} resultat",
    noResults: "Inga resultat hittades",
  },
  admin: {
    admin: "Admin",
    register: "Register",
    contract: "Kontrakt",
    procurement: "Upphandlingar",
    boardMeetings: "Styrelsemöten",
    issues: "Ärenden",
    maintenance: "Underhåll",
    roles: "Roller",
    users: "Användare",
  },
  property: {
    property: "Fastighet",
    properties: "Fastigheter",
    name: "Namn",
    create: "Skapa fastighet",
    parts: "Fastighetsdelar",
    partsEmpty: "Inga fastighetsdelar ännu",
    addPart: "Lägg till fastighetsdel",
    error: "Kunde inte spara fastighet",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "fastighet",
      },
    ],
  },
  propertyPart: {
    propertyPart: "Fastighetsdel",
    propertyParts: "Fastighetsdelar",
    code: "Kod",
    name: "Namn",
    create: "Skapa fastighetsdel",
    propertiesEmpty: "Inga fastigheter kopplade",
    linkedProperties: "Kopplade fastigheter (valfritt)",
    attachProperty: "Koppla fastighet",
    addProperty: "Lägg till fastighet",
    propertyError: "Kunde inte koppla fastighet",
    error: "Kunde inte spara fastighetsdel",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "fastighetsdel",
      },
    ],
  },
  maintenance: {
    planTab: "Plan",
    groupsTab: "Grupper",
    propertiesTab: "Fastigheter",
    propertyPartsTab: "Fastighetsdelar",
    propertyDeleteError:
      "Denna fastighet kan inte raderas eftersom den används av underhållsplaner",
    propertyPartDeleteError:
      "Denna fastighetsdel kan inte raderas eftersom den används av underhållsplaner",
    code: "Kod",
    groupName: "Gruppnamn",
    codes: "Koder",
    codesEmpty: "Inga koder i denna grupp ännu",
    codePlaceholder: "Ny kod",
    addCode: "Lägg till kod",
    description: "Beskrivning",
    cost: "Kostnad",
    yearlyFrequency: "Årlig frekvens",
    createdAt: "Skapad",
    actions: "Åtgärder",
    actionsEmpty: "Inga åtgärder registrerade ännu",
    actionYear: "År",
    actionMonth: "Månad",
    actionAdd: "Lägg till åtgärd",
    deleteAction: "Radera",
    lastAction: "Senaste åtgärd",
    requireAction: "Åtgärd krävs",
    nextAction: "Nästa åtgärd",
    nextActionTitle: "Nästa åtgärd",
    nextActionDue: "Nästa åtgärd ska ske",
    nextActionNoInterval:
      "Ange årlig frekvens på planen för att beräkna nästa åtgärd.",
    actionInCurrentYear: "En åtgärd är registrerad för innevarande år.",
    nextActionOverdue: "Nästa åtgärd skulle ha skett före innevarande år.",
    confirmDeleteAction: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "åtgärd",
      },
    ],
    propertyPart: "Fastighetsdel",
    createPlan: "Skapa åtgärd",
    importPlan: "Importera",
    importTitle: "Importera underhållsplan",
    importPasteHelp:
      "Klistra in rader kopierade från kalkylblad. Kolumner kan separeras med tabb, semikolon eller komma.",
    importPastePlaceholder: "Klistra in rader här…",
    importParse: "Tolka",
    importMapHelp:
      "Koppla varje kolumn till ett fält, eller välj Ignorera för att hoppa över den.",
    importIgnoreColumn: "Ignorera",
    importGroupCode: "Kod",
    importGroupName: "Gruppnamn",
    importPropertyName: "Fastighetsnamn",
    importPropertyPartName: "Fastighetsdelnamn",
    importPropertyPartCode: "Fastighetsdelkod",
    importLastAction: "Senaste åtgärd",
    importPreviewRows: "Visar {shown} av {total} rader.",
    importReadyRows: "{count} rader redo att importeras.",
    importSubmit: "Importera",
    importBack: "Tillbaka",
    importMappingIncomplete:
      "Koppla alla obligatoriska kolumner: kod, gruppnamn, fastighetsnamn, fastighetsdelnamn, fastighetsdelkod och beskrivning.",
    importDateParseError:
      "Ett eller flera värden för senaste åtgärd kunde inte tolkas som datum.",
    importError:
      "Importen misslyckades. Kontrollera kolumnmappning, numeriska värden och datumvärden.",
    importSuccess: "Importerade {created} rader. Hoppade över {skipped} dubbletter.",
    createGroup: "Skapa grupp",
    error: "Kunde inte spara underhållsplan",
    groupError: "Kunde inte spara grupp",
    codeError: "Kunde inte lägga till kod",
    confirmDeletePlan: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "underhållsplan",
      },
    ],
    confirmDeleteGroup: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "grupp",
      },
    ],
    groupDeleteError:
      "Denna grupp kan inte raderas eftersom den används av underhållsplaner",
  },
  apartment: {
    index: "Index",
    apartment: sharedSv.apartment.apartment,
    apartments: sharedSv.apartment.apartments,
    objectNumber: "Objektnummer",
    streetNumber: "Gatuadress",
    apartmentNumber: "Lägenhetsnummer",
    floorNumber: "Våningsplan",
    area: "Yta",
    residents: ":resident.residents",
    share: "Andel",
    primaryOwner: ":resident.primaryOwner",
    state: {
      state: "Status",
      vacant: "Vakant",
      condo: "Bosatdsrätt",
      lease: "Hyresrätt",
      sublet: "Andrahandsupplåten",
    },
    subletTo: "Andrahandsupplåt till",
    viewHoldings: "Visa :holding.holdings[lowercase]",
    viewActiveHoldings: "Visa aktiva :holding.holdings[lowercase]",
    viewLeases: "Visa :lease.leases[lowercase]",
    viewActiveLeases: "Visa aktiva :lease.leases[lowercase]",
    viewSublets: "Visa :sublet.sublets[lowercase]",
    viewActiveSublets: "Visa aktiva :sublet.sublets[lowercase]",
    issueCount: "Ärenden",
    create: "Skapa lägenhet",
    error: "Misslyckades att spara lägenhet",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: ":apartment.apartment[lowercase]",
      },
    ],
  },
  person: {
    person: sharedSv.person.person,
    persons: sharedSv.person.persons,
    personalIdentificationNumber: "Personnummer",
    personalIdentificationNumberAbbreviation: "Pers.nr",
    firstName: "Förnamn",
    lastName: "Efternamn",
    email: "E-post",
    phone: "Telefon",
    age: "Ålder",
    status: {
      status: "Status",
      none: "Ingen",
      owner: "Ägare",
      tenant: "Hyresgäst",
      subtenant: "Andrahandshyresgäst",
    },
    currentApartment: "Nuvarande :apartment.apartment[lowercase]",
    issueCount: "Ärenden",
    error: "Misslyckades att spara person",
    create: "Skapa person",
  },
  organization: {
    organization: sharedSv.organization.organization,
    organizations: sharedSv.organization.organizations,
    corporateRegistrationNumber: "Organisationsnummer",
    corporateRegistrationNumberAbbreviation: "Org.nr",
    name: "Namn",
    email: "E-post",
    phone: "Telefon",
    status: {
      status: "Status",
      none: "Ingen",
      owner: "Ägare",
      tenant: "Hyresgäst",
      subtenant: "Andrahandshyresgäst",
    },
    currentApartment: "Nuvarande :apartment.apartment[lowercase]",
    issueCount: "Ärenden",
    error: "Misslyckades att spara organisation",
    create: "Skapa organisation",
  },
  role: {
    role: sharedSv.role.role,
    roles: sharedSv.role.roles,
    name: "Namn",
    description: "Beskrivning",
    externalDescription: "Extern beskrivning",
    contact: "Kontakt",
    assignedTo: "Tilldelad till",
    assignedToEmpty: "Inga medlemmar tilldelade",
    updatedBy: "Uppdaterad av",
    create: "Skapa roll",
    error: "Kunde inte spara roll",
    confirmDelete: "Är du säker på att du vill radera denna roll?",
    deleteError: "Kunde inte radera roll",
  },
  user: {
    users: "Användare",
    forAssociation: "Visar användare för",
    email: "E-post",
    firstName: ":person.firstName",
    lastName: ":person.lastName",
    type: "Typ",
    active: "Aktiv",
    create: "Skapa användare",
    sendInvite: "Skicka inbjudan via e-post",
    password: "Lösenord",
    passwordPlaceholderKeep: "Lämna tomt för att behålla nuvarande lösenord",
    createError: "Kunde inte skapa användare",
    editError: "Kunde inte uppdatera användare",
    electedRepresentativeType: {
      label: "Förtroendeuppdrag",
      none: "Inget",
      boardMember: "Styrelseledamot",
      alternateBoardMember: "Styrelsesuppleant",
      representative: "Förtroendevald",
      other: "Övrigt",
    },
  },
  holding: {
    holding: sharedSv.holding.holding,
    holdings: sharedSv.holding.holdings,
    owner: {
      owners: "Ägare",
      primary: "Huvudägare",
      share: "Andel",
    },
    residents: ":resident.residents",
    fromDate: ":fromDate",
    toDate: ":toDate",
    contractLength: "Avtalslängd",
    active: ":active",
    state: {
      state: "Status",
      active: "Pågående",
      ended: "Avslutad",
      sublet: "Andrahandsupplåten",
    },
    subletTo: "Andrahandsupplåt till",
    viewApartment: [
      ":viewEntity",
      { entity: ":apartment.apartment[lowercase]" },
    ],
    issueCount: "Ärenden",
    error: "Misslyckades att spara upplåtelse",
    create: "Skapa upplåtelse",
  },
  lease: {
    lease: sharedSv.lease.lease,
    leases: sharedSv.lease.leases,
    residents: ":resident.residents",
    fromDate: ":fromDate",
    toDate: ":toDate",
    contractLength: "Avtalslängd",
    active: ":active",
    state: {
      state: "Status",
      active: "Pågående",
      ended: "Avslutad",
      sublet: "Andrahandsupplåten",
    },
    subletTo: "Andrahandsupplåt till",
    viewApartment: [
      ":viewEntity",
      { entity: ":apartment.apartment[lowercase]" },
    ],
    issueCount: "Ärenden",
    error: "Misslyckades att spara hyresrätt",
    create: "Skapa hyresrätt",
  },
  sublet: {
    sublet: sharedSv.sublet.sublet,
    sublets: sharedSv.sublet.sublets,
    residents: ":resident.residents",
    fromDate: ":fromDate",
    toDate: ":toDate",
    contractLength: "Avtalslängd",
    active: ":active",
    viewApartment: [
      ":viewEntity",
      { entity: ":apartment.apartment[lowercase]" },
    ],
    issueCount: "Ärenden",
    create: "Skapa andrahandsupplåtelse",
    error: "Misslyckades att spara andrahandsupplåtelse",
  },
  boardMeeting: {
    boardMeeting: "Styrelsemöte",
    boardMeetings: "Styrelsemöten",
    create: "Skapa styrelsemöte",
    edit: "Redigera mötesuppgifter",
    name: "Namn",
    date: "Datum och tid",
    location: "Plats",
    locationEmpty: "Ingen plats angiven",
    caller: "Sammankallande",
    called: "Kallade",
    calledHint: "Endast kallade medlemmar kan se mötet när det har kallats.",
    calledEmpty: "Ingen är kallad än",
    attended: "Närvarande",
    attendedEmpty: "Ingen närvaro registrerad",
    secretary: "Sekreterare",
    secretaryNone: "Ej vald",
    verifiers: "Justerare",
    verifiersEmpty: "Inga justerare valda",
    state: "Läge",
    backToList: "Tillbaka till listan",
    you: "du",
    error: "Kunde inte spara styrelsemötet",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: ":boardMeeting.boardMeeting[lowercase]",
      },
    ],
    states: {
      draft: "Utkast",
      call: "Kallelse",
      called: "Kallad",
      opened: "Öppnat",
      ongoing: "Pågående",
      ended: "Avslutat",
      cleaning: "Renskrivning",
      review: "Justering",
      complete: "Klart",
    },
    stateDescriptions: {
      draft: "Förbered dagordningen. Endast underlag kan skrivas och bara du kan se mötet.",
      call: "Förhandsvisning av kallelsen. Underlagen är låsta. Du kan fortfarande gå tillbaka till utkast.",
      called: "Mötet är kallat. Kallade medlemmar kan nu se det och kommentera.",
      opened: "Välj sekreterare och justerare och registrera vilka som närvarar.",
      ongoing: "Skriv slutsatser och beslut. Stäng varje punkt när den är klar.",
      ended: "Mötet är avslutat. Det som antecknades är sparat och kan inte längre ändras.",
      cleaning: "Renskriv protokollet. Varje punkt måste stängas igen innan justering.",
      review: "Justerarna jämför anteckningarna med det renskrivna protokollet och godkänner.",
      complete: "Protokollet är klart och låst.",
    },
    moveTo: {
      call: "Klar för kallelse",
      draft: "Tillbaka till utkast",
      called: "Kalla till möte",
      opened: "Öppna mötet",
      ongoing: "Starta mötet",
      ended: "Avsluta mötet",
      cleaning: "Börja renskriva",
      review: "Skicka till justering",
      complete: "Slutför mötet",
    },
    backToCleaning: "Tillbaka till renskrivning",
    confirmMoveTo: {
      called: "Kalla till mötet? Det går inte längre att gå tillbaka till utkast.",
      ended: "Avsluta mötet? Det går inte att öppna igen.",
      complete: "Slutför mötet? Allt låses permanent.",
    },
    blocked: {
      BoardMeetingNoCalled: "Kalla minst en medlem först.",
      BoardMeetingNoContents: "Lägg till minst en punkt på dagordningen först.",
      BoardMeetingStatementsIncomplete: "Varje punkt behöver ett underlag först.",
      BoardMeetingSecretaryMissing: "Välj en sekreterare först.",
      BoardMeetingVerifiersMissing: "Välj minst en justerare först.",
      BoardMeetingSecretaryIsVerifier: "Sekreteraren kan inte också vara justerare.",
      BoardMeetingContentsOpen: "Stäng alla punkter först.",
      BoardMeetingConfirmationsMissing: "Alla justerare måste godkänna först.",
      BoardMeetingDecisionMissing: "Ange beslutets utfall först.",
    },
    waitingFor: {
      review: "Väntar på att sekreteraren skickar protokollet till justering.",
      complete: "Väntar på att justerarna godkänner.",
    },
    readOnly: "Du kan se mötet men inte ändra det i dess nuvarande läge.",
    agenda: "Dagordning",
    preview: "Kallelse",
    previewIntro: "Så här kommer kallelsen till mötet att se ut.",
    sectionsEmpty: "Dagordningen är tom",
    sectionAdd: "Lägg till avsnitt",
    sectionName: "Avsnittets namn",
    sectionRename: "Byt namn",
    sectionConfirmDelete: "Ta bort avsnittet och alla dess punkter?",
    contentAdd: "Lägg till punkt",
    contentType: "Typ",
    contentTypes: {
      information: "Information",
      decision: "Beslut",
    },
    contentsEmpty: "Inga punkter i avsnittet",
    statement: "Underlag",
    statementPlaceholder: "Vad mötet behöver veta eller besluta om…",
    statementEmpty: "Inget underlag skrivet",
    conclusion: "Slutsats",
    conclusionInformation: "Diskussionsanteckningar",
    conclusionPlaceholder: "Vad som beslutades eller diskuterades…",
    conclusionEmpty: "Inget antecknat",
    decision: "Beslut",
    decisions: {
      resolved: "Beslutat",
      tabled: "Bordlagt",
      dismissed: "Avslaget",
    },
    decisionNone: "Ej beslutat",
    contentStates: {
      open: "Öppen",
      closed: "Stängd",
    },
    close: "Stäng",
    reopen: "Öppna igen",
    contentConfirmDelete: "Ta bort punkten?",
    moveUp: "Flytta upp",
    moveDown: "Flytta ner",
    delete: "Ta bort",
    saving: "Sparar…",
    notedDuringMeeting: "Antecknat under mötet",
    cleanedMinutes: "Renskrivet protokoll",
    attachments: "Bilagor",
    comments: "Kommentarer",
    commentsCount: "Kommentarer ({count})",
    commentsEmpty: "Inga kommentarer än",
    commentPlaceholder: "Skriv en kommentar…",
    commentAdd: "Lägg till kommentar",
    commentDelete: "Ta bort",
    commentEdited: "redigerad",
    commentConfirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "kommentar",
      },
    ],
    people: "Deltagare",
    review: "Justering",
    confirm: "Godkänn protokollet",
    revokeConfirmation: "Återkalla godkännande",
    confirmedAt: "Godkänt {date}",
    notConfirmed: "Ej godkänt",
    history: "Historik",
    createdAt: "Skapat",
  },
  procurement: {
    procurements: "Upphandlingar",
    create: "Skapa upphandling",
    title: "Titel",
    description: "Beskrivning",
    descriptionEmpty: "—",
    tags: "Taggar",
    tagsHint:
      "Skriv och tryck Enter för att lägga till. Förslag kommer från taggar på andra upphandlingar.",
    tagsPlaceholder: "Lägg till en tagg",
    state: "Status",
    statePrevious: "Föregående",
    stateNext: "Nästa",
    stateOpen: "Öppen",
    stateInReview: "Under granskning",
    stateClosed: "Stängd",
    stateCanceled: "Avbruten",
    actionReadyForReview: "Klar för granskning",
    actionClose: "Stäng",
    actionCancel: "Avbryt",
    actionReopen: "Återöppna",
    winner: "Vinnare",
    winnerSelect: "Välj vinnare",
    winnerSubmit: "Sätt vinnare och stäng",
    createContract: "Skapa avtal",
    viewContract: "Visa avtal",
    backToList: "Tillbaka till listan",
    createdBy: "Skapad av",
    createdAt: "Skapad",
    updatedAt: "Uppdaterad",
    organizationsEmpty: "Inga organisationer kopplade",
    organizationAdd: "Lägg till",
    organizationRemove: "Ta bort",
    organizationPrice: "Pris",
    organizationPriceEmpty: "Inget pris",
    organizationFilesCount: "{count} filer",
    files: "Allmänna filer",
    filesGeneral: "Upphandling (ingen organisation)",
    filesAttachTo: "Koppla till",
    lockedForReview:
      "Upphandlingen är under granskning. Redigering och filuppladdning är inaktiverade tills statusen ändras.",
    comments: "Kommentarer",
    commentsEmpty: "Inga kommentarer ännu",
    commentPlaceholder: "Skriv en kommentar…",
    commentAdd: "Lägg till kommentar",
    commentDelete: "Ta bort",
    commentEdited: "redigerad",
    commentConfirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "kommentar",
      },
    ],
    error: "Misslyckades att spara upphandling",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: ":procurement.procurement[lowercase]",
      },
    ],
    procurement: "Upphandling",
  },
  contract: {
    contract: "Kontrakt",
    contracts: "Kontrakt",
    create: "Skapa kontrakt",
    title: "Rubrik",
    total: "Summa",
    description: "Beskrivning",
    tags: "Taggar",
    tagsHint:
      "Skriv och tryck Enter för att lägga till. Förslag hämtas från taggar på andra kontrakt.",
    tagsPlaceholder: "Lägg till en tagg",
    status: "Status",
    statusActive: "Aktiv",
    statusInactive: "Inaktiv",
    cost: "Kostnad",
    invoiceType: "kostnad per",
    invoiceTypeMonthly: "månad",
    invoiceTypeQuarterly: "kvartal",
    invoiceTypeSemiAnnually: "halvår",
    invoiceTypeAnnually: "år",
    counterParty: "Motpart",
    fromDate: "Från",
    toDate: "Till",
    files: "Kontraktsfiler",
    summaryNav: "Sammanfattning",
    summaryTitle: "Kontraktsammanfattning",
    summaryIntro:
      "Endast aktiva avtal. Belopp räknas om till årstotal: månadsvis × 12, kvartalsvis × 4, halvårsvis × 2, årsvis × 1. Saknas faktureringsintervall räknas angivet belopp som en årstotal.",
    summaryActiveList: "Aktiva avtal",
    summaryNoActive: "Inga aktiva avtal.",
    summaryPerYear: "år",
    summaryNoCost: "Ingen kostnad",
    summaryTagBarsTitle: "Kostnader per tagg (staplad per avtal)",
    summaryTagBarsExplain:
      "X-axeln visar taggar och Y-axeln visar årsjusterad kostnad. Varje del av stapeln är ett avtal, så total per tagg inkluderar alla avtal som har taggen.",
    summaryTagBarsNoTags: "Inga taggar med kostnad på aktiva avtal.",
    summaryContractBarsTitle: "Kostnader per avtal",
    summaryContractBarsExplain:
      "X-axeln visar avtal och Y-axeln visar årsjusterad kostnad. En stapel per avtal.",
    summaryPieTitle: "Andel av total årskostnad",
    summaryPieExplain:
      "Varje sektor är ett aktivt avtals årsjusterade kostnad som andel av summan för alla aktiva avtal med belopp.",
    summaryPieEmpty: "Inga kostnader att visa i diagram.",
    summaryOther: "Övriga avtal",
    error: "Misslyckades att spara kontrakt",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: ":contract.contract[lowercase]",
      },
    ],
  },
  issue: {
    issues: "Ärenden",
    board: "Tavla",
    issuesWithoutParent: "Ärenden utan förälder",
    boardCard: "kort",
    boardCards: "kort",
    boardExpandLane: "Expandera simbana",
    boardCollapseLane: "Minimera simbana",
    boardAddIssue: "Lägg till ärende i simbana",
    stateDoneWontdo: "Klar / Kommer inte göras",
    fastumTickets: "Fastum-ärenden",
    fastumSync: "Synk",
    fastumTicketId: "Ärende-ID",
    fastumOpenExternal: "Öppna extern biljett",
    fastumType: "Typ",
    fastumClass: "Klass",
    fastumActionAt: "Åtgärdsdatum",
    fastumTicketsLinked: "Fastum-biljetter",
    fastumTicketsLinkedEmpty: "Inga Fastum-biljetter länkade",
    fastumTicketAdd: "Lägg till biljett",
    fastumTicketTarget: "Biljett",
    fastumTicketTargetPlaceholder: "Exempel: 12345 eller sök på titel",
    fastumLinkedToIssue: "Kopplad till ärende",
    create: "Skapa ärende",
    createGroup: "Skapa grupp",
    identifier: "Ärendenummer",
    descriptionEmpty: "—",
    title: "Rubrik",
    description: "Beskrivning",
    tags: "Taggar",
    tagsHint:
      "Skriv och tryck Enter för att lägga till. Förslag kommer från taggar på andra ärenden.",
    tagsPlaceholder: "Lägg till en tagg",
    type: "Typ",
    typeGroup: "Grupp",
    typeIssue: "Ärende",
    typeTask: "Uppgift",
    parent: "Förälder",
    parentEmpty: "Ingen förälder",
    state: "Status",
    stateTodo: "Att göra",
    stateInProgress: "Pågår",
    stateDone: "Klar",
    stateWontdo: "Kommer inte göras",
    createdBy: "Skapad av",
    createdAt: "Skapad",
    updatedAt: "Uppdaterad",
    links: "Länkar",
    linksEmpty: "Inga länkar tillagda",
    registers: "Register",
    registersEmpty: "Inga register tillagda",
    recordType: "Registertyp",
    recordTarget: "Registerpost",
    recordAdd: "Lägg till registerpost",
    linkRelation: "Relation",
    linkDirection: "Riktning",
    linkDirectionIn: "Inkommande",
    linkDirectionOut: "Utgående",
    linkType: "Länktyp",
    linkTypeRelate: "Relaterad",
    linkTypeBlock: "Blockering",
    linkTarget: "Ärende",
    linkTargetManual: "Manuellt ärende-ID",
    linkTargetSelectPlaceholder: "Välj ärende",
    linkTargetManualPlaceholder: "Exempel: 1234",
    linkAdd: "Lägg till länk",
    linkRemove: "Ta bort",
    linkRelatedTo: "Relaterad till",
    linkBlockedBy: "Blockerad av",
    linkBlocks: "Blockerar",
    linkSelf: "Ett ärende kan inte länkas till sig självt",
    linkDuplicate: "Länken finns redan",
    comments: "Kommentarer",
    commentsEmpty: "Inga kommentarer ännu",
    commentPlaceholder: "Skriv en kommentar…",
    commentAdd: "Lägg till kommentar",
    commentDelete: "Ta bort",
    commentEdited: "redigerad",
    commentError: "Misslyckades att spara kommentar",
    commentConfirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "kommentar",
      },
    ],
    error: "Misslyckades att spara ärende",
    confirmDelete: [
      ":confirm.delete",
      {
        action: ":action.delete[lowercase]",
        entity: "ärende",
      },
    ],
  },
  overview: {
    overview: "Översikt",
    residentType: "Boendetyp",
    residentTypeHolding: ":holding.holding",
    residentTypeLease: ":lease.lease",
    residentTypeSublet: ":sublet.sublet",
    ownershipShare: "Ägandeandel",
    resident: "Boende",
    email: ":person.email",
    phone: ":person.phone",
    identificationNumber: "ID-nummer",
    age: ":person.age",
    contractLength: ":holding.contractLength",
    viewApartment: [":viewEntity", { entity: ":apartment.apartment[lowercase]" }],
    viewHolding: [":viewEntity", { entity: ":holding.holding[lowercase]" }],
    viewLease: [":viewEntity", { entity: ":lease.lease[lowercase]" }],
    viewSublet: [":viewEntity", { entity: ":sublet.sublet[lowercase]" }],
  },
  resident: {
    resident: "Boende",
    residents: "Boenden",
    primaryOwner: "Huvudägare",
  },
  tenant: {
    tenant: "Hyresgäst",
    tenants: "Hyresgäster",
  },
  subtenant: {
    subtenant: "Andrahandshyresgäst",
    subtenants: "Andrahandshyresgäster",
  },
  account: {
    accounts: "Konton",
  },
  profile: {
    title: "Profil",
    email: "E-postadress",
    currentPassword: "Nuvarande lösenord",
    updatePassword: "Uppdatera lösenord",
    password: "Lösenord",
    repeatPassword: "Upprepa lösenord",
    submit: "Uppdatera",
    sender: "Avsändare",
    incorrectOldPassword: "Felaktigt nuvarande lösenord",
  },
  footer: {
    organizationNumber: "Org.nr",
    contact: "Kontakt",
    email: "E-post",
    phone: "Tel",
    followUs: "Följ oss",
  },
  action: {
    action: "Åtgärd",
    actions: "Åtgärder",
    delete: "Radera",
  },
  viewEntity: "Visa {entity}",
  yes: "Ja",
  no: "Nej",
  ok: "OK",
  cancel: "Avbryt",
  close: "Stäng",
  fullscreen: {
    enter: "Helskärm",
    exit: "Avsluta helskärm",
  },
  select: {
    placeholder: "Välj ett alternativ",
  },
  confirm: {
    delete: "Är du säker på att du vill {action} denna {entity}?",
  },
  fromDate: "Från",
  toDate: "Till",
  customName: "Eget namn",
  useCustomName: "Använd eget namn",
  defaultName: "Standardnamn",
  active: "Aktiv",
  status: "Status",
  year: "år",
  years: "år",
  month: "månad",
  months: "månader",
  empty: "Ingen data att visa",
  error: {
    code: {
      title: "Servern svarade med fel",
      message: "Följande fel uppstod: {error}",
    },
    ApartmentNotFound: {
      title: ":apartment.apartment hittades inte",
      message: "Den :apartment.apartment[lowercase] hittades inte",
    },
    ApartmentHasHoldingsOrLeases: {
      title:
        ":apartment.apartment har :holding.holdings[lowercase] eller :lease.leases[lowercase]",
      message:
        "Denna :apartment.apartment har :holding.holdings[lowercase] eller :lease.leases[lowercase]. Ta bort dem innan du kan radera :apartment.apartment[lowercase]",
    },
    ApartmentIndexAlreadyExists: {
      title: ":apartment.apartment index finns redan",
      message:
        "Denna :apartment.apartment[lowercase] index finns redan. Välj ett annat index",
    },
    MaintenancePlanGroupHasMaintenancePlans: {
      title: "Gruppen används av underhållsplaner",
      message:
        "Ta bort eller tilldela om underhållsplaner som använder koder i denna grupp innan du raderar den.",
    },
    MaintenancePlanCodeHasMaintenancePlans: {
      title: "Koden används av underhållsplaner",
      message:
        "Ta bort eller tilldela om underhållsplaner som använder denna kod innan du raderar den.",
    },
    MaintenancePlanCodeAlreadyExists: {
      title: "Koden finns redan i denna grupp",
      message: "Välj en annan kod för denna grupp.",
    },
    PropertyHasMaintenancePlans: {
      title: "Fastigheten används av underhållsplaner",
      message:
        "Ta bort underhållsplaner som använder fastighetsdelar på denna fastighet innan du raderar den.",
    },
    PropertyPartHasMaintenancePlans: {
      title: "Fastighetsdelen används av underhållsplaner",
      message:
        "Ta bort underhållsplaner som använder denna fastighetsdel innan du raderar den.",
    },
  },
} as Locale;
